/** Profile field options for QikTruck Careers (South Africa logistics) */

export const SA_PROVINCES = [
  "Eastern Cape",
  "Free State",
  "Gauteng",
  "KwaZulu-Natal",
  "Limpopo",
  "Mpumalanga",
  "Northern Cape",
  "North West",
  "Western Cape",
];

export const AVAILABILITY_OPTIONS = [
  { value: "full_time", label: "Full-time" },
  { value: "part_time", label: "Part-time" },
  { value: "contract", label: "Contract / temp" },
  { value: "flexible", label: "Flexible / shifts" },
];

export const EMPLOYED_OPTIONS = [
  { value: "yes", label: "Yes, I have a job now" },
  { value: "no", label: "No, I am not employed" },
];

export const DRIVER_LICENSE_OPTIONS = [
  { value: "", label: "Select licence code" },
  { value: "code_8", label: "Code 8 (light motor vehicle)" },
  { value: "code_10", label: "Code 10 (heavy vehicle)" },
  { value: "code_14", label: "Code 14 (extra-heavy articulated)" },
  { value: "ec", label: "EC (articulated combination)" },
  { value: "learner", label: "Learner's licence only" },
  { value: "none", label: "No driver's licence yet" },
];

export const TARGET_ROLE_OPTIONS = [
  { value: "driver", label: "Driver / delivery operator" },
  { value: "dispatcher", label: "Dispatcher / coordinator" },
  { value: "warehouse", label: "Warehouse / picker" },
  { value: "fleet_supervisor", label: "Fleet supervisor" },
  { value: "operations_manager", label: "Operations manager" },
  { value: "business_owner", label: "Transport business owner" },
  { value: "customer_service", label: "Customer service / shipper liaison" },
  { value: "other", label: "Other logistics role" },
];

export const PROGRAM_OPTIONS = [
  { value: "", label: "Select a program" },
  { value: "driver", label: "Driver Program" },
  { value: "operations", label: "Operations Program" },
  { value: "leadership", label: "Leadership Program" },
  { value: "business", label: "Business Program" },
  { value: "customer", label: "Customer Program" },
];

export const DOC_TYPE_OPTIONS = [
  { value: "drivers_license", label: "Driver's licence" },
  { value: "pdp", label: "PDP (Professional driving permit)" },
  { value: "matric", label: "Matric / NSC certificate" },
  { value: "tertiary", label: "Diploma / degree" },
  { value: "professional_cert", label: "Professional certificate (forklift, DG, etc.)" },
  { value: "cv", label: "CV / resume" },
  { value: "other", label: "Other qualification" },
];

export const DOC_TYPE_LABELS = Object.fromEntries(
  DOC_TYPE_OPTIONS.map((o) => [o.value, o.label])
);

export const PROFILE_SECTIONS = {
  identity: ["firstname", "lastname", "mobilenumber", "idnumber", "date_of_birth"],
  location: ["city", "province", "suburb"],
  career: ["target_role", "primary_academy_slug", "years_experience", "availability", "currently_employed"],
  licences: ["driver_license_code", "has_pdp", "promoterlicense"],
};

export const ALLOWED_UPLOAD_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/png",
  "image/webp",
];

export const CV_UPLOAD_TYPES = [
  ...ALLOWED_UPLOAD_TYPES,
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const CV_UPLOAD_ACCEPT =
  ".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/jpeg,image/png,image/webp";

export const QUALIFICATION_UPLOAD_ACCEPT =
  ".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/jpeg,image/png,image/webp";

export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
